module.exports = __webpack_public_path__ + "img/success.e35ebd92.svg";